<template>
  <li class="dropdownItem dropdownItem__customerInfo">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      電話派遣
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/phoneHail'"
          v-if="permissionCallCar"
        >
          電話派車頁面
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/hailStateV2'"
          v-if="permissionInstanceTransactionRecord"
        >
          叫車紀錄
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/DispatchArea'"
          v-if="permissionDispatchArea"
        >
          派遣區
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/ShiftArea'"
          v-if="permissionScheduledArea"
        >
          排班站
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="shiftBoardurl"
          v-if="permissionScheduledBoard"
        >
          排班看板
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/RecordHailBill'"
          v-if="permissionHailBillPage"
        >
          後派單
        </router-link>
      </li>
    </ul>
  </li>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  props: [
    'permissionCallCar',
    'permissionInstanceTransactionRecord',
    'permissionHailBillPage',
    'permissionDispatchArea',
    'permissionScheduledBoard',
    'permissionScheduledArea',
  ],
  data() {
    return {
      shiftBoardurl: '/serviceMain/ShiftBoard',
    }
  },
  mounted() {
    const MainTeamCode = Cookies.get('GladTeamCode')
    if (MainTeamCode === '300')
      this.shiftBoardurl = '/serviceMain/ShiftBoard_v1'
  },
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownPhoneHail.vue